export default __webpack_public_path__ + "static/media/ic_gmx_40.eeb7dc00.svg";